import React from 'react'

const NextArrow = ({ className, onClick }) => (
    <button className={`${className} !right-0 z-10`} onClick={onClick} type="button">
        <img
            src="../../assets/images/icons/arrow-chevron-right.svg"
            alt="next"
            className="w-6 h-6"
        />
    </button>
);

export default NextArrow